import { useMixpanel } from '@/hooks/use-mixpanel';
import { Time } from '@/ui/Time';
import { Box, Flex } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { KText } from 'ui-library/components';
import { HighlightedText } from '../components/HighlightedText';

export const OutreachSearchItem = ({
  outreach,
  showBorderBottom,
  searchTerm,
}) => {
  const { track } = useMixpanel();

  return (
    <Link
      to={`/flows/${outreach?.id}`}
      onClick={() => {
        track({
          event: 'global-serach-item-click',
          prop: { type: 'outreach' },
        });
      }}
    >
      <Flex
        minH="40px"
        py="18px"
        gap="20px"
        cursor="pointer"
        borderBottom={`${showBorderBottom ? '1px solid var(--kula-dark-secondary-100, #F3F3F3)' : ''}`}
        _hover={{ backgroundColor: 'var(--kula-dark-secondary-25, #f6f7f7)' }}
        px="8px"
        mx="8px"
        className="universal--search--item"
        borderRadius="8px"
      >
        <Flex flexDirection="column" gap="4px">
          <KText
            fontSize="14px"
            lineHeight="18px"
            letterSpacing="0.16px"
            textTransform="capitalize"
          >
            <HighlightedText text={outreach?.title} highlight={searchTerm} />
          </KText>
          <Flex gap="10px" alignItems="center">
            <KText textTransform="capitalize">{outreach?.status}</KText>
            <Box
              w="5px"
              h="5px"
              borderRadius="full"
              backgroundColor="secondary-700"
            />
            <KText textTransform="capitalize">{outreach?.user.name}</KText>
            <Box
              w="5px"
              h="5px"
              borderRadius="full"
              backgroundColor="secondary-700"
            />

            <Time time={outreach?.created_at} color="secondary-700" />
          </Flex>
        </Flex>
      </Flex>
    </Link>
  );
};
